
export default {
  props: {
    blogs: { type: Array, required: true },
    closeSearch: { type: Function, required: true },
    loading: { type: Boolean, required: true },
  },

  computed: {
    swiperClass() {
      return `center-search-blogs-swiper`;
    },
    getBlogProps() {
      return (this.blogs || []).map(({ title, image, url }) => {
        return {
          title,
          image,
          url,
        };
      });
    },
  },
};
